import { Component, Input } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { MapPointInterface } from "../../../core/models/mapping";
import { PointDoc } from "../../../core/schema/point-schema";
import { PointService } from "../../../core/services";

@Component({
    selector: 'app-map-point-summary',
    templateUrl: './map-point-summary.component.html'
  })
  export class MapPointSummaryComponent {

    @Input('mapPoint') set mapPoint ( mp: MapPointInterface ) {
        if ( !mp ) {
            this.pointQuery$ = null
        } else {
            this.pointQuery$ = this.pointService.rxCollection.findOne(mp.pointId).$
        }
        this._mapPoint = mp
    }

    _mapPoint : MapPointInterface

    pointQuery$ : BehaviorSubject<PointDoc>

    bExpanded = false
    
    constructor(
            public pointService: PointService
    ){

    }
}  